// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__3_ZLS"};